module.exports = __webpack_public_path__ + "media/goforajourney/img/born-small-groups-ba7cecfc92a02c553f7cfdde25a9d79c.jpeg";